<template>
  <v-card>
    <v-card-title>{{ $t('routes.roles.index') }}</v-card-title>
    <Datatable
      get_endpoint="roles"
      :delete_endpoint="hasLaravelRoute('roles.delete') ? 'roles' : null"
      :header_items="headers"
      :create_route="hasVueRoute('roles.add') ? 'roles.add' : null"
      :edit_route="hasVueRoute('roles.edit') ? 'roles.edit' : null"
      user_friendly_identifier="id"
      :item_on_click="
        item => {
          if (hasVueRoute('roles.edit')) {
            this.$router.push({
              name: 'roles.edit',
              params: { id: item.id },
            })
          }
        }
      "
      :show_delete="
        item => {
          return item.id !== $store.state.user.id && hasLaravelRoute('roles.delete')
        }
      "
      type="entity_with_article.role"
    >

      <template v-slot:[`item.roles_to_assign`]="{ item }">
          <v-chip
            small 
             v-for="role_to_assign in item.assignable_roles"
             :key="'role_to_assign' + role_to_assign.id"
            >{{ role_to_assign.translations[$i18n.locale].name }}
          </v-chip>
      </template>
    </Datatable>
  </v-card>
</template>

<script>
import Datatable from '@/components/Datatable/Datatable.vue'

export default {
  components: {
    Datatable,
  },
  data() {
    return {
      headers: [
        {
          text: 'label.id',
          value: 'id',
          search_type: 'number',
          sortable: true,
        },
        {
          text: 'label.name',
          value: 'translations.' + this.$i18n.locale + '.name',
          sortable: true,
          search_type: 'text',
        },

        {
          text: 'label.roles_to_assign',
          value: 'roles_to_assign',
          sortable: false,
        },
      ],
    }
  },
}
</script>
